<template>
  <div>
    <!-- Department Tabs - Responsive -->
    <div id="departamentos-tab" class="flex flex-row w-full overflow-x-auto">
      <button
        v-for="(departamento, index) in getDepartments"
        :key="index"
        @click="selectedDepartamento = departamento"
        :class="{
          'bg-blue-500 text-white': selectedDepartamento === departamento,
          'bg-gray-200': selectedDepartamento !== departamento
        }"
        class="flex-shrink-0 px-3 py-2 md:px-4 md:py-3 text-sm md:text-base whitespace-nowrap"
      >
        {{ departamento.name }}
      </button>
    </div>

    <!-- Desktop Table View (hidden on mobile) -->
    <div
      class="hidden md:block w-full overflow-x-auto mt-4"
      v-if="filteredByDepartment.length > 0"
    >
      <table class="tiny-table">
        <tr>
          <th>Line</th>
          <th>Price Online</th>
          <th>Price Repair Shop</th>
          <th>Price wholesale</th>
          <th v-if="userCanSeePrecio4">Price Export</th>
          <th v-if="userCanSeePrecio5">Price GrupoNKR</th>
          <th v-if="userCanSeePrecio6">Price WH2</th>
          <th>Qty Available</th>
          <th>Warehouse</th>
        </tr>
        <tr v-for="(entry, index) in filteredByDepartment" :key="index">
          <td>{{ entry.line }}</td>
          <td>{{ entry.online | currencyFormatted(true) }}</td>
          <td>
            {{ entry.repairShop | currencyFormatted(true) }}
          </td>
          <td>{{ entry.wholesale | currencyFormatted(true) }}</td>
          <td v-if="userCanSeePrecio4">
            {{ entry.precio4 | currencyFormatted(true) }}
          </td>
          <td v-if="userCanSeePrecio5">
            {{ entry.precio5 | currencyFormatted(true) }}
          </td>
          <td v-if="userCanSeePrecio6">
            {{ entry.precio6 | currencyFormatted(true) }}
          </td>
          <td
            class="text-xl"
            :class="{
              'text-red-500': entry.stock < 1,
              'text-green-500 font-bold text-2xl': entry.stock >= 1
            }"
          >
            {{ entry.stock }}
          </td>
          <td>{{ entry.warehouse }}</td>
        </tr>
      </table>
    </div>

    <!-- Mobile Card View (hidden on desktop) -->
    <div
      class="md:hidden mt-4 space-y-3"
      v-if="filteredByDepartment.length > 0"
    >
      <div
        v-for="(entry, index) in filteredByDepartment"
        :key="index"
        class="bg-white border border-gray-300 rounded-lg p-4 shadow-sm"
      >
        <!-- Stock and Line Header -->
        <div
          class="flex justify-between items-center mb-3 pb-3 border-b border-gray-200"
        >
          <div>
            <span class="text-xs text-gray-500 uppercase">Line</span>
            <div class="font-semibold text-gray-800">{{ entry.line }}</div>
          </div>
          <div class="text-right">
            <span class="text-xs text-gray-500 uppercase block">Stock</span>
            <div
              class="text-2xl font-bold"
              :class="{
                'text-red-500': entry.stock < 1,
                'text-green-500': entry.stock >= 1
              }"
            >
              {{ entry.stock }}
            </div>
          </div>
        </div>

        <!-- Warehouse -->
        <div class="mb-3">
          <span class="text-xs text-gray-500 uppercase">Warehouse</span>
          <div class="font-medium text-gray-800">{{ entry.warehouse }}</div>
        </div>

        <!-- Prices Grid -->
        <div class="grid grid-cols-2 gap-3">
          <div>
            <span class="text-xs text-gray-500 uppercase block">Online</span>
            <div class="font-semibold text-blue-600">
              {{ entry.online | currencyFormatted(true) }}
            </div>
          </div>
          <div>
            <span class="text-xs text-gray-500 uppercase block">
              Repair Shop
            </span>
            <div class="font-semibold text-blue-600">
              {{ entry.repairShop | currencyFormatted(true) }}
            </div>
          </div>
          <div>
            <span class="text-xs text-gray-500 uppercase block">Wholesale</span>
            <div class="font-semibold text-blue-600">
              {{ entry.wholesale | currencyFormatted(true) }}
            </div>
          </div>
          <div v-if="userCanSeePrecio4">
            <span class="text-xs text-gray-500 uppercase block">Export</span>
            <div class="font-semibold text-blue-600">
              {{ entry.precio4 | currencyFormatted(true) }}
            </div>
          </div>
          <div v-if="userCanSeePrecio5">
            <span class="text-xs text-gray-500 uppercase block">GrupoNKR</span>
            <div class="font-semibold text-blue-600">
              {{ entry.precio5 | currencyFormatted(true) }}
            </div>
          </div>
          <div v-if="userCanSeePrecio6">
            <span class="text-xs text-gray-500 uppercase block">WH2</span>
            <div class="font-semibold text-blue-600">
              {{ entry.precio6 | currencyFormatted(true) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="text-red-400 text-center py-6 mt-4">
      Price or stock info about this product is not available.
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductStockAndPrice",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedDepartamento: null
    };
  },
  mounted() {
    this.selectedDepartamento = this.getActiveDepartment;
  },
  computed: {
    ...mapGetters("general", ["getActiveDepartment", "getDepartments"]),
    filteredByDepartment() {
      return this.product.stockAndPrice.filter(
        variation =>
          variation.departamentoCodigo ===
          (this.selectedDepartamento?.code || "all")
      );
    },
    userCanSeePrecio4() {
      return this.$store.getters["auth/userHasPermission"]("price_precio4");
    },
    userCanSeePrecio5() {
      return this.$store.getters["auth/userHasPermission"]("price_precio5");
    },
    userCanSeePrecio6() {
      return this.$store.getters["auth/userHasPermission"]("price_precio6");
    }
  }
};
</script>
